import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d881370"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["height", "width", "onClick", "innerHTML"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke", "r", "stroke-width"]
const _hoisted_8 = {
  class: "arrow__image",
  fill: "none",
  height: "23",
  viewBox: "0 0 58 23",
  width: "58",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = ["stroke"]
const _hoisted_10 = ["stroke"]
const _hoisted_11 = ["stroke"]
const _hoisted_12 = {
  class: "arrow__circle",
  draggable: "false",
  fill: "none",
  height: "11",
  viewBox: "0 0 11 13",
  width: "13",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = ["stroke", "r", "stroke-width"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.5895 16.135V18.5962H0.222451V0.289678H3.06421V16.135H11.5895Z",
  fill: "#B3B3B3"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3.21265 2.67473V9.25898H7.19619C9.39094 9.25898 10.6469 8.05377\n        10.6469 5.96051C10.6469 3.918 9.31482 2.67473 7.12007\n        2.67473H3.21265ZM3.21265 11.5552V18.5962H0.370889V0.289678H7.4626C11.2305\n        0.289678 13.5775 2.47174 13.5775 5.88439C13.5775 8.35825 12.2581 10.3627\n        10.0253 11.1112L14.123 18.5962H10.8499L7.12007 11.5552H3.21265Z",
  fill: "#B3B3B3"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { BrushMapTeeth } from '@/pages/BrushMapPage/brushMapTeeth'
import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { BrushMapController } from '../brushMapController'
import { Tooth } from '../tooth'

interface Props {
  brushMapTeeth: BrushMapTeeth
  brushMapBrushes: BrushMapAddedBrushes
  brushMapController: BrushMapController
  isDentalFlossMode: boolean
  qrCodeEnabled: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapTeeth: null,
    brushMapBrushes: null,
    brushMapController: null,
    isDentalFlossMode: { type: Boolean },
    qrCodeEnabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  brushMapTeeth: BrushMapTeeth
  brushMapBrushes: BrushMapAddedBrushes
  brushMapController: BrushMapController
  isDentalFlossMode: boolean
  qrCodeEnabled: boolean
}



const route = useRoute()
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const patientId = computed(() => route.params.patientId)

const qrCode = computed(() => {
  if (!isPreviewMode.value) {
    return
  }

  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  return `${domain}/api/web/admin/patients/${patientId.value}/get-qr`
})

function updateArrowState(e: MouseEvent, tooth: Tooth) {
  const TAG_NAME_CIRCE = 'circle'
  const element = e.target as HTMLDivElement

  if (props.isDentalFlossMode) {
    toggleDentalFlossMode(tooth)
    return
  }

  if (element.tagName === TAG_NAME_CIRCE) {
    tooth.isBleeding = !tooth.isBleeding
    return
  }

  if (tooth.isDentalFloss) {
    tooth.isDentalFloss = false
  }

  props.brushMapController.updateArrowState(tooth)
}

function toggleDentalFlossMode(tooth: Tooth): void {
  tooth.isDentalFloss = !tooth.isDentalFloss

  if (tooth.isDentalFloss) {
    props.brushMapController.handleDeleteColorFromAddedBrushes(tooth.baseColor)
    tooth.clearArrowColors()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "teeth",
    class: _normalizeClass([{
      'is-preview': _unref(isPreviewMode),
      'brush-map__teeth_preview': _unref(isPreviewMode),
      'is-normal': !_unref(isPreviewMode),
    }, "brush-map__teeth"])
  }, [
    (_unref(isPreviewMode) && __props.qrCodeEnabled)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(qrCode),
          alt: "",
          class: "brush-map__qr"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.brushMapTeeth.teeth, (tooth) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tooth.id,
        class: "brush-map__tooth"
      }, [
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass([tooth.toothClass, "brush-map__image"]),
          height: tooth.heightImage,
          width: tooth.widthImage,
          onClick: ($event: any) => (tooth.updateStatusTooth()),
          innerHTML: tooth.getImageTooth()
        }, null, 10, _hoisted_2)),
        _createElementVNode("span", {
          class: _normalizeClass([tooth.numberClass, "number-tooth"])
        }, _toDisplayString(tooth.id), 3),
        (tooth.arrowClass && !_unref(isPreviewMode))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([tooth.arrowClass, "arrow brush-map__image"]),
              draggable: "false"
            }, [
              (_openBlock(), _createElementBlock("svg", {
                fill: "none",
                height: "59",
                viewBox: "0 0 16 59",
                width: "16",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: ($event: any) => (updateArrowState($event, tooth))
              }, [
                (tooth.arrowColor[0] !== '#b3b3b3')
                  ? (_openBlock(), _createElementBlock("path", {
                      key: 0,
                      stroke: tooth.arrowColor[0],
                      d: "M13.9261 46.4146L7.96482 33.6518L2.03702 45.6803",
                      "stroke-linecap": "round",
                      "stroke-width": "3.41646"
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                _createElementVNode("path", {
                  stroke: tooth.isDentalFloss ? '#b3b3b3' : '#fff',
                  d: "M7.94531 57.5918L7.94531 1.5918",
                  "stroke-dasharray": "0.85 2.56",
                  "stroke-linecap": "round",
                  "stroke-width": "1.70823"
                }, null, 8, _hoisted_5),
                (tooth.arrowColor[1] !== '#b3b3b3')
                  ? (_openBlock(), _createElementBlock("path", {
                      key: 1,
                      stroke: tooth.arrowColor[1],
                      d: "M1.99971 13.2001L7.96096 25.963L13.8888 13.9345",
                      "stroke-linecap": "round",
                      "stroke-width": "3.41646"
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("circle", {
                  stroke: tooth.isBleeding ? '#ff0000' : '#b3b3b3',
                  cx: "8",
                  cy: "30",
                  fill: "white",
                  r: tooth.isBleeding ? 5 : 4.1,
                  "stroke-width": tooth.isBleeding ? 2 : 1.70823
                }, null, 8, _hoisted_7)
              ], 8, _hoisted_3))
            ], 2))
          : _createCommentVNode("", true),
        (tooth.arrowClass && _unref(isPreviewMode))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([tooth.arrowClass, "arrow brush-map__image"]),
              draggable: "false"
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                (tooth.arrowColor[0] !== '#b3b3b3')
                  ? (_openBlock(), _createElementBlock("path", {
                      key: 0,
                      stroke: tooth.arrowColor[0],
                      d: "M47.6165 8.96911L33.8405 11.9098L44.2292 20.389",
                      "stroke-linecap": "round",
                      "stroke-width": "3.41646"
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("path", {
                  stroke: tooth.isDentalFloss ? '#b3b3b3' : '#fff',
                  d: "M1.10352 5.93311L56.621 16.1825",
                  "stroke-dasharray": "0.85 2.56",
                  "stroke-linecap": "round",
                  "stroke-width": "1.70823"
                }, null, 8, _hoisted_10),
                (tooth.arrowColor[1] !== '#b3b3b3')
                  ? (_openBlock(), _createElementBlock("path", {
                      key: 1,
                      stroke: tooth.arrowColor[1],
                      d: "M12.209 14.0471L25.8748 10.6306L15.1984 2.5166",
                      "stroke-linecap": "round",
                      "stroke-width": "3.41646"
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ])),
              (_openBlock(), _createElementBlock("svg", _hoisted_12, [
                _createElementVNode("circle", {
                  stroke: tooth.isBleeding ? '#ff0000' : '#b3b3b3',
                  cx: "5.27966",
                  cy: "6.28503",
                  fill: "white",
                  r: tooth.isBleeding ? 5 : 4.1,
                  "stroke-width": tooth.isBleeding ? 2 : 1.70823
                }, null, 8, _hoisted_13)
              ]))
            ], 2))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass([{ 'brush-map__symbol-left_preview': _unref(isPreviewMode) }, "brush-map__symbol-left"]),
      fill: "none",
      height: "19",
      viewBox: "0 0 12 19",
      width: "12",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_15, 2)),
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass([{ 'brush-map__symbol-right_preview': _unref(isPreviewMode) }, "brush-map__symbol-right"]),
      fill: "none",
      height: "19",
      viewBox: "0 0 15 19",
      width: "15",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_17, 2))
  ], 2))
}
}

})